import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import FullCalendar from '@fullcalendar/react';
import frLocale from '@fullcalendar/core/locales/fr';
import './LocalizedFullCalendar.scss';

/**
 * A wrapper around FullCalendar that automatically applies localization
 * based on the current i18next language setting.
 *
 * @param {import('@fullcalendar/core').CalendarOptions & { firstDay?: number }} props - FullCalendar props
 * @param {number} [props.firstDay] - The first day of the week (0 = Sunday, 1 = Monday, etc.). Overrides locale default.
 * @param {React.Ref} ref - Forwarded ref to the FullCalendar component
 */
const LocalizedFullCalendar = forwardRef(({ firstDay, ...props }, ref) => {
    const { i18n } = useTranslation();

    return (
        <div className="localized-full-calendar">
            <FullCalendar
                ref={ref}
                locales={[frLocale]}
                locale={i18n.language}
                firstDay={firstDay}
                {...props}
            />
        </div>
    );
});

LocalizedFullCalendar.displayName = 'LocalizedFullCalendar';

export default LocalizedFullCalendar;

